import React, { FunctionComponent, memo } from "react";
import { useLabel } from "../../../hooks/useLabel";
import Script from "next/script";

const GTMComponent: FunctionComponent = () => {
  const {
    label: { gtm },
  } = useLabel();

  if (!gtm) {
    return null;
  }

  return (
    <>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtm}');
        `}
      </Script>
    </>
  );
};

export const GTM = memo(GTMComponent);
